<template>
  <div class="single-curve">
    <div class="cure-top">
      <div class="cure-top-title">二氧化碳传感器曲线</div>
      <div class="cure-top-select">
        <div style="margin-right: 1vw">
          <DropDownInput type="0" :items="sensorValue" content="" @sendValue="sendValue" @sendInfo="showInfo"></DropDownInput>
        </div>
        <div style="display: flex">
          <div class="input-contain">
            <div class="input-title">X：</div>
            <div class="input-wrapper" style="width: 5vw">
              <input  v-model="historyInfo.siteX"/>
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title">Y：</div>
            <div class="input-wrapper" style="width: 5vw">
              <input v-model="historyInfo.siteY"/>
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title">Z：</div>
            <div class="input-wrapper" style="width: 5vw">
              <input v-model="historyInfo.siteZ"/>
            </div>
          </div>
        </div>
        <div class="input-date-wrapper">
          <el-date-picker
            v-model="value"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <div class="query button" @click="buttonSearch">查询</div>
      </div>
    </div>
    <div class="loading-data" v-if="loading">
      <i class="el-icon-loading"></i>
      <div>加载中，请稍后···</div>
    </div>
    <div class="chart-wrapper" v-show="!loading" id="myChart4" v-if="rows.length > 0"></div>
    <div class="none-data" v-if="!loading && rows.length<1">暂无数据</div>
  </div>
</template>

<script>
import DropDown from '../../../../components/DropDownSingle.vue'
import DropDownInput from '../../../../components/DropDownInput.vue'
import {queryRtNodeMonitInfo, queryNodeHistoryInfo, getMaintainData} from '../../../../api/maintain'
import {renderTime} from '../../../../tools/methods'
let echarts = require('echarts')
let myChart4
export default {
  name: 'SingleWater',
  components: { DropDown, DropDownInput },
  data () {
    return {
      percentage: '',
      rows: [],
      loading: false,
      moduleType: '02',
      nodeType: '02',
      sensorValue: [],
      siteLocation: '',
      value: '',
      historyInfo: {
        endTime: '',
        nodeId: '',
        siteX: '',
        siteY: '',
        siteZ: '',
        startTime: ''
      },
      name_C: '二氧化碳/(PPM)',
      legendData: [],
      maxC: '',
      minC: '',
      markLine_C: '',
      markLine_C_: ''
    }
  },
  watch: {
    value: function () {
      console.log(this.value)
      this.historyInfo.startTime = this.value !== null ? this.value[0] : ''
      this.historyInfo.endTime = this.value !== null ? this.value[1] : ''
    }
  },
  created () {
    this.handleSearch()
  },
  methods: {
    buttonSearch: function () {
      this.loading = true
      queryNodeHistoryInfo(this.historyInfo).then(res => {
        if (res.code === 500) {
          this.loading = false
          this.$message({
            message: res.message,
            type: 'warning',
            center: 'true',
            duration: '1000'
          })
        } else {
          res.data.map(item => {
            item.createdTime = renderTime(item.createdTime)
          })
          console.log(res)
          this.rows = res.data
          this.loading = false
          let that = this
          setTimeout(function () {
            that.getCharts()
            myChart4.on('legendselectchanged', function (obj) {
              console.log(obj)
              if (obj.selected.正常值 === true) {
                that.legendData = [
                  {name: '正常值'},
                  {
                    name: '预警值',
                    icon: 'line',
                    textStyle: {color: '#a84200'}
                  }
                ]
                that.markLine_C_ = that.markLine_C
                that.getCharts()
              }
              if (obj.selected.正常值 === false) {
                that.legendData = [
                  {name: '正常值'}
                ]
                that.markLine_C_ = ''
                that.getCharts()
              }
              if (obj.selected.预警值 === false) {
                that.markLine_C_ = ''
                that.getCharts()
              }
              if (obj.selected.预警值 === true) {
                that.markLine_C_ = that.markLine_C
                that.getCharts()
              }
            })
          }, 200)
        }
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    sendValue: function (value) {
      console.log(value)
      this.handleSearch(value)
    },
    showInfo: function (data) {
      this.historyInfo.nodeId = data.nodeId
      console.log(data)
      let body = {
        siteId: data.siteId,
        siteType: data.siteType
      }
      getMaintainData(body).then(res => {
        console.log(res)
        if (res.data !== null) {
          this.legendData = [
            {name: '正常值'},
            {
              name: '预警值',
              icon: 'line',
              textStyle: {color: '#a84200'}
            }
          ]
          this.markLine_C = {
            symbol: 'none',
            lineStyle: {type: 'solid', color: '#a84200'},
            label: {show: false},
            data: [
              {
                name: '',
                yAxis: res.data.concentrationCo2Upper
              },
              {
                name: '',
                yAxis: res.data.concentrationCo2Lower
              }
            ]
          }
          this.markLine_C_ = this.markLine_C
          this.maxC = res.data.concentrationCo2Upper + 1000
          this.minC = res.data.concentrationCo2Lower - 1000
        } else {
          this.legendData = []
          this.markLine_C = ''
          this.markLine_C_ = ''
          this.maxC = ''
          this.minC = ''
        }
      }).catch(err => {
        console.log(err)
      })
    },
    handleSearch: function (value) {
      let body = {
        moduleType: this.moduleType,
        nodeType: this.nodeType,
        nodeId: value
      }
      queryRtNodeMonitInfo(body).then(res => {
        console.log(res)
        this.sensorValue = res.data.rows
      }).catch(err => {
        console.log(err)
      })
    },
    getCharts: function () {
      this.getChart4()
      window.onresize = function () {
        myChart4.resize()
      }
    },
    getChart4: function () {
      console.log(this.rows)
      let date = []
      let value = []
      let maxC = this.rows[0].moist
      let minC = this.rows[0].moist
      if (this.rows.length < 25) {
        this.percentage = 100
      } else {
        this.percentage = 2500 / this.rows.length
      }
      this.rows.map(item => {
        date.push(item.createdTime)
        value.push(item.concentrationCo2)
        if (item.concentrationCo2 > maxC) {
          maxC = item.concentrationCo2
        }
        if (item.concentrationCo2 < minC) {
          minC = item.concentrationCo2
        }
      })
      myChart4 = echarts.init(document.getElementById('myChart4'))
      myChart4.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            lineStyle: {type: 'dashed'}
          }
        },
        textStyle: {color: '#ffffff'},
        legend: {
          x: 'right',
          y: 'top',
          itemGap: 50,
          textStyle: {color: '#fff323'},
          data: this.legendData
        },
        grid: {
          top: '15%',
          right: '0',
          left: '0.5%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          splitLine: {show: false},
          axisTick: false,
          axisLine: {
            lineStyle: {color: '#32b16c'}
          },
          axisLabel: {
            textStyle: {
              fontSize: 8
            },
            interval: 0,
            rotate: 45
          },
          data: date
        },
        yAxis: {
          type: 'value',
          scale: 'true',
          max: this.maxC || maxC + 1,
          min: this.minC || minC - 1,
          axisTick: false,
          splitLine: {
            lineStyle: {
              // 使用深浅的间隔色
              color: ['#2a2f57']
            }
          },
          axisLine: {
            lineStyle: {color: '#32b16c'}
          },
          splitNumber: '5',
          name: this.name_C
        },
        dataZoom: [
          {
            type: 'slider',
            show: false,
            start: 0,
            end: this.percentage,
            handleSize: 8
          },
          {
            type: 'inside',
            start: 0,
            end: this.percentage
          },
          {
            type: 'slider',
            show: false,
            yAxisIndex: 0,
            filterMode: 'empty',
            width: 12,
            height: '70PPM',
            handleSize: 8,
            showDataShadow: false,
            left: '93PPM'
          }
        ],
        series: [
          {
            name: '预警值',
            type: 'line'
          },
          {
            name: '正常值',
            type: 'line',
            symbol: 'circle',
            itemStyle: {
              normal: {
                lineStyle: {
                  color: '#fff323'
                },
                color: '#fff323'
              }
            },
            data: value,
            markLine: this.markLine_C_
          }
        ]
      })
    }
  }
}
</script>

<style scoped>
  @import "SingleCure.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/crib/singleCurve/SingleCarbonDioxide.vue